/**
 * Component: Ajax Cart
 * ------------------------------------------------------------------------------
 * Create a mini cart with increase and decrease quantity function.
 * bump
 * 
 * @namespace ajaxCart
 */
import { formatMoney } from '@shopify/theme-currency';
import * as cart from '@shopify/theme-cart';
import { enableBodyScroll } from 'body-scroll-lock';
import axios from 'axios';

import { on } from '../helpers/utils';
import cssClasses from '../helpers/cssClasses';

import {
  quantitySelector,
  quantitySelectorTemplate,
} from './quantity-selector';

/**
 * DOM selectors.
 */
const selectors = {
  cart: '[js-ajax-cart="cart"]',
  close: '[js-ajax-cart="close"]',
  container: '[js-ajax-cart="container"]',
  counter: '[js-ajax-cart="counter"]',
  footer: '[js-ajax-cart="footer"]',
  freeShipping: '[js-freeshipping="container"]',
  itemList: '[js-ajax-cart="list"]',
  lineItem: '[js-cart-table="lineItem"]',
  open: '[js-ajax-cart="open"]',
  quantity: '[js-ajax-cart="quantity"]',
  quantitySelector: '[js-cart="quantitySelector"]',
  totalPrice: '[js-ajax-cart="totalPrice"]',
};

/**
 * Export default AjaxCart.
 * test
 */
export default () => {
  const cartPage = window.location.pathname;

  const urlParams = new URLSearchParams(window.location.search);
  const shouldCartOpenFromParams = urlParams.get('cart-open');
  if (shouldCartOpenFromParams) {
    getCartJson();
  }

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    cart: document.querySelector(selectors.cart),
    open: [...document.querySelectorAll(selectors.open)],
    close: [...document.querySelectorAll(selectors.close)],
    quantity: [...document.querySelectorAll(selectors.quantity)],
    totalPrice: [...document.querySelectorAll(selectors.totalPrice)],
    counter: [...document.querySelectorAll(selectors.counter)],
    footer: document.querySelector(selectors.footer),
    freeShipping: document.querySelector(selectors.freeShipping),
    itemList: document.querySelector(selectors.itemList),
  };

  function init() {
    if (theme.ajaxCart.enable === false || cartPage === '/cart') {
      return false;
    }

    setBusListeners();
    setEventListeners();
  }

  function setBusListeners() {
    Karmoon.EventBus.listen(
      ['AddToCart:itemRemoved', 'AddToCart:itemAdded'],
      () => {
        getCartJson();
      }
    );

    Karmoon.EventBus.listen(
      ['AddToCart:isRemoving', 'AjaxCart:isUpdating'],
      () => {
        cartUpdating();
      }
    );

    Karmoon.EventBus.listen('AjaxCart:updated', (cartData) => {
      cartUpdated();
      handleOpenCart(cartData);
    });
  }

  function setEventListeners() {
    document.documentElement.addEventListener('keydown', handleKeydown);

    nodeSelectors.open.forEach((item) => {
      on('click', item, () => getCartJson());
    });

    nodeSelectors.close.forEach((item) => {
      on('click', item, () => cartClose());
    });
  }

  function handleOpenCart(cartData) {
    cartOpen();
    cartRender(cartData);
    cartCounter(cartData);
    updateTotal(cartData);
  }

  /**
   * Ajax call to get all cart data json.
   */
  function getCartJson() {
    axios
      .get(`/cart.js?no-cache}`)
      .then((response) => {
        Karmoon.EventBus.emit('AjaxCart:updated', response.data);
      })
      .catch((error) => {
        window.console.error(error);
        return error;
      });
  }

  /**
   * If key press is ESC close AjaxCart.
   */
  function handleKeydown(event) {
    if (event.keyCode === 27) {
      cartClose();
    }
  }

  async function clearCart() {
    const cart = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const cartData = await cart.json();
    return cartData;
  }


  async function clearSamples(d) {

    let updates = {};

    for (let i in d) {
      updates[d[i]] = 0;
    }

    const cart = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    const cartData = await cart.json();
    return cartData;
  }

  async function removeGiftItems(items, t) {
    try {
      let updates = {};

      for (let i in items) {
        updates[items[i]] = 0;
      }

      const cart = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
      const cartData = await cart.json();
      Karmoon.EventBus.emit('AddToCart:itemRemoved');

      console.log(cartData);
    } catch (err) {
      console.error(err);
    }
  }

  async function checkForGift() {

    const cart = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const cartData = await cart.json();

    let giftThreshold = parseFloat(window?.freeGiftv2?.threshold);
    let freeGiftThreshold = parseFloat(window?.freeGiftWithPurcahse?.threshold);

    let ct = (cartData.total_price / 100).toFixed(2);

    let cartTotal = formatMoney(
      cartData?.total_price,
      theme.moneyFormat
    ).replace('.00', '');

    let _total = parseFloat(cartTotal.replace('&pound;', ''));

    let giftCounter = 0;
    let freeGFiftCounter = 0;

    let normalCount = 0;

    let samplesToRemove = [];

    cartData?.items?.map((i) => {
      if (i?.properties?._sample_item == true) {
        giftCounter = giftCounter + i?.quantity;
      }

      if (i?.properties?._gift_item == true) {
        freeGFiftCounter = freeGFiftCounter + i?.quantity;
      }

      if(i?.product_type == "Gift Card") {

      } else if(i?.product_type == "Sample") {
        samplesToRemove.push(i?.key);
      } else {
        normalCount = normalCount + i?.quantity
      }
    });

    // remove gift ites below threshold
    if (_total <= giftThreshold) {
      let _items = [];

      cartData?.items?.map((i) => {
        if (i?.properties?._sample_item == true) {
          giftCounter = giftCounter + i?.quantity;
          _items.push(i?.key);
        }
      });

      await removeGiftItems(_items, 'default');
      Karmoon.EventBus.emit('AddToCart:itemRemoved');
    }


    if (ct <= freeGiftThreshold) {
      let _items = [];

      cartData?.items?.map((i) => {
        if (i?.properties?._gift_item == true) {
          freeGFiftCounter = freeGFiftCounter + i?.quantity;
          _items.push(i?.key);
        }
      });

      await removeGiftItems(_items, 'GWP');
      Karmoon.EventBus.emit('AddToCart:itemRemoved');
    }

    if(normalCount == 0) {
      await clearSamples(samplesToRemove);
      Karmoon.EventBus.emit('AddToCart:itemRemoved');
    } else if (giftCounter == cartData.item_count) {
      await clearCart();
      Karmoon.EventBus.emit('AddToCart:itemRemoved');
    }
     else {
      return null;
    }
  }

  /**
   * Handle quantity updates.
   * @param {HTMLElement} element - Quantity selector node element.
   */
  function handleQuantityEvent(element) {

    Karmoon.EventBus.emit('AjaxCart:isUpdating');

    let k = element.closest(selectors.lineItem).dataset.key;
    let q = parseInt(element.querySelector('input').value, 10);

    const data = {
      index: element.closest(selectors.lineItem).dataset.index,
      key: element.closest(selectors.lineItem).dataset.key,
      quantity: parseInt(element.querySelector('input').value, 10),
    };


    let updates = {
      [k]: q
    };

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then((response) => {
      // if (!response.ok) {
      //   let data = response;
      //   console.log(data.body);
      // }
      return response.json();
    })
    .then((res)=>{
      if(res.status == 422 && res.message == "Not allowed to order more than 1 of the same sample") {
        showValidationError(res.message);
        Karmoon.EventBus.emit('AddToCart:itemAdded');
      } else {
        checkForGift();
        Karmoon.EventBus.emit('AddToCart:itemAdded');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });

    // try {
    //   cart
    //   .updateItem(data.key, { quantity: data.quantity })
    //   .then(() => {
    //     checkForGift();
    //     Karmoon.EventBus.emit('AddToCart:itemAdded');
    //   })
    // } catch (error) {
    //   console.error(`There was an error ${JSON.stringify(error)}`)

    // }

    // cart
    //   .updateItem(data.key, { quantity: data.quantity })
    //   .then(() => {
    //     checkForGift();
    //     Karmoon.EventBus.emit('AddToCart:itemAdded');
    //   })
    //   .catch((error) => {
    //     console.error(`There was an error ${JSON.stringify(error)}`)
    //     if (typeof response === 'undefined') {
    //       return;
    //     }

    //     throw new Error('Could not update item data', error);
    //   });
  }

  /**
   * Open Ajax Cart Open.
   */
  function cartOpen() {
    Karmoon.EventBus.emit('AjaxCart:Open');
    nodeSelectors.container.classList.add(cssClasses.active);
    // disableBodyScroll(nodeSelectors.container);

    // nodeSelectors.itemList.setAttribute('style', 'overflow:auto;');
    document.querySelector('body').classList.add('mobile-lock');
    document.querySelector('html').classList.add('mobile-lock');
  }

  /**
   * Close Ajax Cart Open.
   */
  function cartClose() {
    Karmoon.EventBus.emit('AjaxCart:Close');
    nodeSelectors.container.classList.remove(cssClasses.active);
    enableBodyScroll(nodeSelectors.container);

    document.querySelector('body').classList.remove('mobile-lock');
    document.querySelector('html').classList.remove('mobile-lock');
  }

  /**
   * Instantiate quantity selectors using id.
   * - Callback has a timer to reduce number of calls.
   */
  function constructQuantitySelectors() {
    const quantitySelectors = document.querySelectorAll(
      selectors.quantitySelector
    );

    [...quantitySelectors].forEach((item) => {
      quantitySelector(`${item.id}`, () => {
        window.clearTimeout(window.timer);
        window.timer = window.setTimeout(() => {
          handleQuantityEvent(item);
        }, 250);
      }).init();
    });
  }

  /**
   * Build cart template
   * @param {Object} data - Cart data.
   */
  function cartRender(data) {
    // console.log('the cart: ', data)
    const cartItems = data.items;

    if (cartItems.length) {

      if(data.item_count == 1){
        if(cartItems[0].product_type == "Gift Card") {
          if (nodeSelectors.freeShipping) {
            nodeSelectors.freeShipping.classList.add('visually-hidden');
          }

          clearCart();
          Karmoon.EventBus.emit('AddToCart:itemRemoved');

        } else {
          if(nodeSelectors.freeShipping) {
            nodeSelectors.freeShipping.classList.remove('visually-hidden');
          }
        }
      } else {
        if(nodeSelectors.freeShipping) {
          nodeSelectors.freeShipping.classList.remove('visually-hidden');
        }
      }

      const cartTemplate = getCartTemplate(data);
      nodeSelectors.itemList.innerHTML = cartTemplate;
      if(nodeSelectors.footer) {
        nodeSelectors.footer.classList.add(cssClasses.active);
      }
      if (nodeSelectors.freeShipping) {
        nodeSelectors.freeShipping.classList.add(cssClasses.active);
      }
    } else {
      const emptyCartTemplate = getEmptyCart(data);
      nodeSelectors.itemList.innerHTML = emptyCartTemplate;
      if(nodeSelectors.footer) {
        nodeSelectors.footer.classList.remove(cssClasses.active);
      }
      if (nodeSelectors.freeShipping) {
        nodeSelectors.freeShipping.classList.remove(cssClasses.active);
      }
    }

    containerHeight();
    constructQuantitySelectors();
  }

  /**
   * Get cart template
   * @param {Object} data - Cart data.
   * @returns {String}
   */
  function getCartTemplate(data) {
    let giftCounter = 0;
    let freeGiftCounter = 0;

    let activeGifts = 0;
    let activeFreeGifts = 0;

    // let cartTotal = data?.total_price;

    const formatNumber = num => (num / 100).toFixed(2);

    let giftTriggersToCheck = window?.freeGiftv2?.triggerItems;
    let giftThreshold = parseFloat(window?.freeGiftv2?.threshold);
    let shouldShowAutomatically = window?.freeGiftv2.isAutoShow;

    let gwp_giftTriggersToCheck = window?.freeGiftWithPurcahse?.triggerItems;
    let gwp_giftThreshold = parseFloat(window?.freeGiftWithPurcahse?.threshold);
    let gwp_shouldShowAutomatically = window?.freeGiftWithPurcahse.isAutoShow;

    let cartTotal = formatMoney(data.total_price, theme.moneyFormat).replace(
      '.00',
      ''
    );

    let _total = parseFloat(cartTotal.replace('&pound;', ''));

    function runGiftCheck(_id) {
      giftTriggersToCheck.map((i) => {
        if (i.includes(_id)) {
          giftCounter = giftCounter + 1;
        }
      });

      gwp_giftTriggersToCheck.map((i) => {
        if (i.includes(_id)) {
          freeGiftCounter  = freeGiftCounter  + 1;
        }
      });


    }

    data.items.map((i) => {
      runGiftCheck(i.product_id);
      if (i?.properties?._sample_item == true) {
        activeGifts = activeGifts + 1;
      }

      if (i?.properties?._gift_item == true) {
        activeFreeGifts = activeFreeGifts + 1;
      }
    });

    // Create a new cart instance and call the methods from outside their classes
    const _freeGift = document.querySelector(`[gift-ref]`);
    const _freeGWP = document.querySelector(`[freegift-ref]`);


    if(_freeGift) {
      if(shouldShowAutomatically && data.item_count >= 1 && activeGifts == 0) {
        if(data.item_count == 1 && data.items[0].product_type == "Gift Card") {
          _freeGift.hide();
        } else {
          _freeGift.show();
        }
      }
    }


    if(_freeGWP) {
      
      if(gwp_shouldShowAutomatically && data.item_count >= 1 && activeFreeGifts == 0) {
        if(data.item_count == 1 && data.items[0].product_type == "Gift Card") {
          _freeGWP.hide();
        } else if(formatNumber(data?.total_price) >= gwp_giftThreshold) {
          _freeGWP.show();
        } else {
          _freeGWP.hide();
        }
      }
    }


    if (giftCounter >= 1 && _freeGift && activeGifts == 0 && _total >= giftThreshold) {
      _freeGift.show();
    } else {
      if (_freeGift && _total < giftThreshold) {
        _freeGift.hide();
      }
    }


    if (freeGiftCounter  >= 1 &&  _freeGWP && activeFreeGifts == 0 && _total >= gwp_giftThreshold) {
      _freeGWP.show();
    } else {
      if ( _freeGWP && _total <  gwp_giftThreshold) {
        _freeGWP.hide();
      }
    }

    if (data.item_count == 0 && _freeGift) {
      _freeGift.hide();
    }

    if (data.item_count == 0 && _freeGWP) {
      _freeGWP.hide();
    }

    const lineItemsTemplate = data.items
      .map((item, index) => getLineItemTemplate(item, index))
      .join('');

    return `${lineItemsTemplate}`;
  }

  let bundleItems = [];

  /**
   * Return line item HTML block.
   * @param {Object} item - Cart item.
   * @param {interger} index - Index count.
   * @returns {HTMLElement}
   */
  function getLineItemTemplate(item, index) {
    let bundleItemIDs = [];

    const isBundleItem = item?.properties?._bundle_item ? true : false;
    const isBundleParent = item?.properties?._bundle_parent ? true : false;

    if (isBundleItem || isBundleParent) {
      bundleItems.push(item);
    }

    if (isBundleParent) {
      bundleItemIDs.push(`${item?.properties?._bundle_item_1_id}:1`);
      bundleItemIDs.push(`${item?.properties?._bundle_item_2_id}:1`);
    }

    const freeGiftItem = checkFreeGift(item);
    const cartVariantTitle = getVariantTitle(item);
    const cartLinePrice = getLinePrice(item);
    const cartLinePriceBackup = getLinePriceBackup(item);

    const createQuantitySelector = quantitySelectorTemplate(item, index);
    // const freeGiftMessage = ((freeGiftItem.text === 'Free Gift') ? freeGiftItem.text : cartLinePrice);
    const freeGiftMessage = (p) => {
      if (freeGiftItem.text === 'Free Gift') {
        return freeGiftItem.text;
      } else if (bundleItems && item.line_price == 0) {
        return cartLinePriceBackup;
      } else {
        return cartLinePrice;
      }
    };

    const preOrder = getPreOrder(item);
    const preOrderHTML = getPreOrderHTML(preOrder);

    const isSample = item?.properties?._sample_item ? true : false;
    const isFreeGift = item?.properties?._gift_item ? true : false;

    const itemsToRemove = bundleItems.map((i) => {
      return i.key;
    });

    // display the associated products within the bundle
    const determineBundle = () => {
      if (isBundleParent) {
        return `
        <br/>
        <span>Your bundle includes:<span><br/>
        <ul class="bundle-breakdown">
          <li>
            <div>
              ${item.properties._bundle_item_1_name}
            </div>
          </li>
          <li>
          <div>
          ${item.properties._bundle_item_2_name}
          </div>
        </li>
        </ul>
        `;
      } else {
        return '';
      }
    };

    const determineSample = () => {
      if (isSample) {
        return `
        <br/>
        <span class="sample-tag">Sample</span> <div style="margin-left: 10px; display: inline-block;"> x${item.quantity}</div><br/>
        `;
      } else if(isFreeGift){
        return `
        <br/>
        <span class="sample-tag">Free Gift</span> <div style="margin-left: 10px; display: inline-block;"> x${item.quantity}</div><br/>
        `;
      } else {
        return '';
      }
    };

    const getBundleKey = () => {
      return item?.properties?._bundle_key;
    };

    const cartRow = `
          <div
            class="cart-ajax__row cart-data ${freeGiftItem.className}"
            data-key="${item.key}"
            data-index="${index}"
            js-cart-table="lineItem"
            data-is-bundle-parent="${isBundleParent}"
            data-is-bundle-item="${isBundleItem}"
            data-bundle-id="${getBundleKey()}"
            style="${isBundleItem && 'display: none;'}"
            >
            <div class="cart-ajax__row__column">
              <a href="${isSample || isFreeGift ? '#' : item.url}" title="Product Image" class="js-click-gtm cart-ajax__row__image" style="background-image: url(${
      item.image
    })"></a>
            </div>
            <div class="cart-ajax__row__column md:flex md:justify-between">
              <div class="cart-ajax__row__title">
                <a href="${isSample || isFreeGift ? '#' : item.url}" title="${
      item.product_title
    }" class="js-click-gtm text-md sm:text-lg md:text-xl w-2/3 lg:w-full leading-tight">
                  ${item.product_title}
                  <small class="cart-ajax__row__variant">
                    ${cartVariantTitle}
                    ${determineBundle()}
                    ${determineSample()}
                  </small>
                  ${preOrderHTML}
                </a>

                <button
                  js-cart="remove"
                  data-item-key="${item.key}"
                  data-bundle-remove="${isBundleParent}"
                  data-bundle-items-to-remove="${itemsToRemove}"
                  data-bundle-id="${item?.properties?._bundle_key}"
                  data-to-remove="${bundleItemIDs}"
                  name="Remove"
                  type="button"
                  style="${isBundleItem && 'opacity: 0; visibility: hidden;'}"
                  class="cart-ajax__remove underline text-sm md:text-base font-light"
                  tabindex="0">
                  x Remove
                </button>

              </div>

              ${
                isBundleItem || isBundleParent || isSample || isFreeGift
                  ? ''
                  : createQuantitySelector
              }

              <span data-default=${
                item.price
              } class="cart-ajax__row__money text-lg md:text-xl" style="${
      isBundleItem || isSample || isFreeGift ? 'opacity: 0; visibility: hidden;' : ''
    }">
              ${freeGiftMessage(item.price)}
              </span>
              </div>
          </div>`;

    return cartRow;
  }

  /**
   * Return Variant title if available.
   * @param {Object} item - Cart item.
   * @returns {HTMLElement}
   */
  function getVariantTitle(item) {
    return item.variant_title === null ? '' : item.variant_title;
  }

  /**
   * Return Properties of Pre-Order if available.
   * @param {Object} item - Cart item.
   * @returns {HTMLElement}
   */
  function getPreOrder(item) {
    if (item.properties) {
      if (item.properties.hasOwnProperty('Pre-Order')) {
        return 'Pre-Order';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  /**
   * Return Properties of Pre-Order if available.
   * @param {String} item - 'Pre-Order' or ''.
   * @returns {HTMLElement}
   */
  function getPreOrderHTML(item) {
    if (item == 'Pre-Order') {
      return `<small class="cart-ajax__row__variant">
        ${item}
      </small>`;
    } else {
      return '';
    }
  }

  /**
   * Return true if this is a gift item.
   * @param {Object} item - Cart item.
   * @returns {HTMLElement}
   */
  function checkFreeGift(item) {
    const freeGiftItem = theme.freeGift.id;
    let freeGift = {
      className: '',
      text: '',
    };

    if (item.id === freeGiftItem) {
      freeGift = {
        className: ' cart-ajax__row--free-gift',
        text: 'Free Gift',
      };
    }

    return freeGift;
  }

  /**
   * Return formatted line item price.
   * @param {Object} item - Cart item.
   * @returns {HTMLElement}
   */
  function getLinePrice(item) {
    const cartLinePrice = formatMoney(
      item.line_price,
      theme.moneyFormat
    ).replace('.00', '');

    return cartLinePrice;
  }

  function getLinePriceBackup(item) {
    const p = formatMoney(item.price, theme.moneyFormat).replace('.00', '');

    return p;
  }

  /**
   * Update total cart price.
   * @returns {HTMLElement}
   */
  function getEmptyCart() {
    const emptyCart = `
        <div class="cart-ajax__empty">
          <h3>Your cart is empty…</h3>
          <a href="/collections/" class="button" title="Collections">Shop Collections</a>
        </div>
      `;

      const _freeGift = document.querySelector(`[gift-ref]`);
      const _freeGWP = document.querySelector(`[freegift-ref]`);

      if (_freeGift) {
        _freeGift.hide();
      }
  
      if (_freeGWP) {
        _freeGWP.hide();
      }

    return emptyCart;
  }

  /**
   * Update total items in cart counter.
   * @param {Object} data - Cart data.
   */
  function cartCounter(data) {
    [...nodeSelectors.counter].forEach((item) => {
      item.innerHTML = `(${data.item_count})`;

      if (data.item_count === 0) {
        item.classList.remove(cssClasses.active);
      } else {
        item.classList.add(cssClasses.active);
      }
    });
  }

  /**
   * Update total cart price.
   * @param {Object} data - Cart data.
   */
  function updateTotal(data) {
    const cartTotal = formatMoney(data.total_price, theme.moneyFormat).replace(
      '.00',
      ''
    );

    [...nodeSelectors.totalPrice].forEach((item) => {
      item.innerHTML = `<span class=money>${cartTotal}</span>`;
    });
  }

  /**
   * Add loading state when adding to cart.
   */
  function cartUpdating() {
    nodeSelectors.container.classList.add(cssClasses.loading);
  }

  /**
   * Remove loading state from Ajax cart.
   */
  function cartUpdated() {
    nodeSelectors.container.classList.remove(cssClasses.loading);
  }

  function containerHeight() {
    const container = document.querySelector('.cart-ajax__list-container');
    const tools = document.querySelector('.cart-ajax__tools');
    const containerMathHeight = `${tools.offsetTop - container.offsetTop}px`;
    container.style.height = containerMathHeight;
  }


  function showValidationError(m) {
    if(document.querySelector('.cart-error')) {
      document.querySelector('.cart-error span').innerText = `Error: ${m}`;
      document.querySelector('.cart-error').classList.remove('hidden');
    }

    setTimeout(()=>{
      document.querySelector('.cart-error').classList.add('hidden');
    },2000)

  }

  /**
   * Custom component for ahndling 'build a bundle' functionality
   *
   * HOW IT WORKS (IN A NUTSHELL)
   * ===========================
   * Using data attributes, we keep track of what the uSer selects (Sub product title and variant ID)
   * This then gets passed to the product forms hidden prop inputs and is filtered in the cart template
   * We also attach a unique ID to each parent 'bundle product' which groups all items together as '1 product'
   *
   * @class BundleWrapper
   * @typedef {BundleWrapper}
   * @extends {HTMLElement}
   */
  class BundleWrapper extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('.bundle-option').forEach((el) => {
        el.addEventListener('click', (e) => {
          if (el.getAttribute('data-once', 'true')) {
            el.parentElement.classList.toggle('closed');
            el.setAttribute('data-once', false);
            // el.setAttribute('selected', false);
          } else {
            if (el.getAttribute('selected') == 'true') {
              el.setAttribute('data-once', true);
              el.parentElement.classList.toggle('closed');
              // this.closeSame(el.parentElement);
            } else {
              el.parentElement.classList.add('closed');
            }
          }

          this.clearActive(el.parentElement.id);
          el.setAttribute('selected', true);
          this.hydrateBundles(
            el.parentElement.id,
            el.getAttribute('value'),
            el
          );

          if (this.getAttribute('data-has-same') == 'false') {
            if (el.parentElement.id == 'bundle-option-1') {
              let t = this.querySelector(`#bundle-option-2`);
              t.querySelectorAll('.bundle-option').forEach((i) => {
                i.removeAttribute('disabled');
              });
              t.querySelector(`#o-${el.getAttribute('value')}`).setAttribute(
                'disabled',
                true
              );
            } else {
              let t = this.querySelector(`#bundle-option-1`);
              t.querySelectorAll('.bundle-option').forEach((i) => {
                i.removeAttribute('disabled');
              });
              t.querySelector(`#o-${el.getAttribute('value')}`).setAttribute(
                'disabled',
                true
              );
            }
          }
        });
      });
    }

    /**
     * Watch for changes t out components data attributes / values
     * Only listen for the array below
     *
     * @static
     * @readonly
     * @type {{}}
     */
    static get observedAttributes() {
      return ['data-bundle-option-1', 'data-bundle-option-2', 'bundle-key'];
    }

    /**
     * Returns a random string
     *
     * @returns {string} - Used for generating the bundle ID
     */
    randomString() {
      let characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz123456789';
      let lenString = 21;
      let randomstring = '';
      for (let i = 0; i < lenString; i++) {
        let rnum = Math.floor(Math.random() * characters.length);
        randomstring += characters.substring(rnum, rnum + 1);
      }
      return randomstring;
    }

    /**
     * On mount call our render function
     */
    connectedCallback() {
      this.render();
    }

    /**
     * This gets called everytime the page mounts or gets refreshed
     * Essentially adds all the needed data attributes that couldn't be added via liquid
     */
    // render
    render() {
      // This is important, this attacheds to the bundle item and its sub items when added to the cart, this is what groups them as '1 product'
      sessionStorage.setItem('BundleID', this.randomString());

      let o1 = this.querySelector('#bundle-option-1');
      let o2 = this.querySelector('#bundle-option-2');

      // Get the inital selected bundle products via JS and attaach to our custom component
      let option1 = o1.querySelector('.bundle-option[selected]');
      let option2 = o2.querySelector('.bundle-option[selected]');
      this.setAttribute('data-bundle-option-1', option1.getAttribute('value'));
      this.setAttribute('data-bundle-option-2', option2.getAttribute('value'));

      this.setAttribute(
        'clean-option-1',
        option1.querySelector('span').innerHTML
      );
      this.setAttribute(
        'clean-option-2',
        option2.querySelector('span').innerHTML
      );

      if (this.getAttribute('data-has-same') == 'false') {
        o1.querySelector(`#o-${option2.getAttribute('value')}`).setAttribute(
          'disabled',
          true
        );
        o2.querySelector(`#o-${option1.getAttribute('value')}`).setAttribute(
          'disabled',
          true
        );
      }

      document.querySelector('#bi1').value =
        option1.querySelector('span').innerHTML;
      document.querySelector('#bi2').value =
        option2.querySelector('span').innerHTML;

      document.querySelector('#bi1_id').value = option1.getAttribute('value');
      document.querySelector('#bi2_id').value = option2.getAttribute('value');

      this.setAttribute('bundle-key', sessionStorage.getItem('BundleID'));
      document.querySelector('#bundle_key').value =
        sessionStorage.getItem('BundleID');
    }

    /**
     * Automatically runs when any of our wacthed data attributes changes
     *
     * When 1 bundle product gets added to the cart, the bundle ID will change and reset ready for the next
     * This is what keeps things seperate
     *
     * @param {string} name
     * @param {string} oldValue
     * @param {string} newValue
     */
    attributeChangedCallback(name, oldValue, newValue) {
      if (name == 'bundle-key') {
        document.querySelector('#bundle_key').value =
          sessionStorage.getItem('BundleID');
      }
    }

    // Removes any 'selected / active' state on the bundle options list
    clearActive(p) {
      let _parent = this.querySelector(`#${p}`);
      _parent.querySelectorAll('.bundle-option').forEach((el) => {
        el.removeAttribute('selected');
      });
    }

    /**
     * Runs when a users chooses a new option for their bundle / overwrites the defualt pre selected
     *
     * @param {string} s - QuerySelector (ID) for either the 1st / 2nd options wrapper
     * @param {string} id - The freshly selected product variant ID
     * @param {HTMLElement} el - The clicked element
     */
    hydrateBundles(s, id, el) {
      this.setAttribute(`data-${s}`, id);
      if (s.includes('1')) {
        let _title = el.querySelector('span').innerText;
        this.setAttribute('clean-option-1', _title);
        document.querySelector('#bi1').value = _title;
        document.querySelector('#bi1_id').value = id;
      } else {
        let _title = el.querySelector('span').innerText;
        this.setAttribute('clean-option-2', _title);
        document.querySelector('#bi2').value = _title;
        document.querySelector('#bi2_id').value = id;
      }
    }
  }

  customElements.define('bundle-wrapper', BundleWrapper);

  class BundleSelect extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('bundle-select', BundleSelect);

  class BundleOption extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('bundle-option', BundleOption);

  class SamplesOpen extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (e) => {
        if (document.querySelector('#sample-picker')) {
          document
            .querySelector('#sample-picker')
            .classList.remove('visually-hidden');
        }
      });
    }
  }

  customElements.define('samples-open', SamplesOpen);


  class GiftsOpen extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (e) => {
        if (document.querySelector('#free-gift-picker')) {
          document
            .querySelector('#free-gift-picker')
            .classList.remove('visually-hidden');
        }
      });
    }
  }

  customElements.define('gifts-open', GiftsOpen);

  class SamplesWrapper extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('select').forEach((el) => {
        el.addEventListener('change', (e) => {
          this.hydrateSamples(e.currentTarget.id, e.currentTarget.value);
        });
      });

      this.querySelector('#samples-add').addEventListener('click', (e) => {
        if(this.getAttribute('s-count') == "1") {
          if(this.getAttribute('data-sample-1') != "") {
            this.addSamples();
          }
        } else if(this.getAttribute('s-count') == "2") {
          if(this.getAttribute('data-sample-1') != "" && this.getAttribute('data-sample-2') != "") {
            this.addSamples();
          }
        } else {
          if(this.getAttribute('data-sample-1') != "" && this.getAttribute('data-sample-2') != "" && this.getAttribute('data-sample-3') != "") {
            this.addSamples();
          }
        }

      });

      this.querySelector('#samples-closer').addEventListener('click', (e) => {
        this.parentElement.classList.add('visually-hidden');
      });
    }

    static get observedAttributes() {
      return ['data-sample-1', 'data-sample-2', 'data-sample-3'];
    }

    attributeChangedCallback() {
      if(this.getAttribute('s-count') == "1") {
        if(this.getAttribute('data-sample-1') != "") {
          this.querySelector('#samples-add').classList.remove('disabled');
        }
      } else if(this.getAttribute('s-count') == "2") {
        if(this.getAttribute('data-sample-1') != "" && this.getAttribute('data-sample-2') != "") {
          this.querySelector('#samples-add').classList.remove('disabled');
        }
      } else {
        if(this.getAttribute('data-sample-1') != "" && this.getAttribute('data-sample-2') != "" && this.getAttribute('data-sample-3') != "") {
          this.querySelector('#samples-add').classList.remove('disabled');
        }
      }
    }

    render() {
      this.setAttribute('gift-ref', '');

      const defaultValues = this.dataToObject(this.dataset);

      Object.keys(defaultValues).forEach((key, i) => {
        const value = defaultValues[key];
        // this.disableDefaults(key, value, i + 1);
      });
    }

    disableDefaults(i, id, index) {

      if(this.getAttribute('s-count') == "1") {
        return false;
      } else if(this.getAttribute('s-count') == "2") {
        this.querySelectorAll(`select#${i} option`).forEach((el, _index) => {
          if(el.selected && _index == 0) {
            el.nextElementSibling.disabled = true;
          } else if (el.selected && _index == 1) {
            el.previousElementSibling.disabled = true;
          }
        })
      } else {
        // 3 rule
        this.querySelectorAll(`select#${i} option`).forEach((el, _index) => {
          if(el.selected && _index == 0) {
            el.nextElementSibling.disabled = true;
            el.nextElementSibling.nextElementSibling.disabled = true;
          } else if (el.selected && _index == 1) {
            el.previousElementSibling.disabled = true;
            el.nextElementSibling.disabled = true;
          } else if (el.selected && _index == 2) {
            el.previousElementSibling.disabled = true;
            el.previousElementSibling.previousElementSibling.disabled = true;

          }
        })

      }
    }

    connectedCallback() {
      this.render();
    }

    show() {
      document.querySelector('#cs-wrapper').classList.remove('visually-hidden');
      if(document.querySelector('#sample-prompt')) {
        document.querySelector('#sample-prompt').classList.remove('visually-hidden');
      }
    }

    hide() {
      document.querySelector('#cs-wrapper').classList.add('visually-hidden');
      if(document.querySelector('#sample-prompt')) {
        document.querySelector('#sample-prompt').classList.add('visually-hidden');
      }
    }

    unRender() {
      // document.querySelector('#cs-wrapper').remove();
      // this.remove();
      this.hide();
    }

    hydrateSamples(s, id) {
      this.setAttribute(`data-${s}`, id);

      if(this.getAttribute('s-count') == "3") {

        let id1 = this.getAttribute('data-sample-1');
        let id2 = this.getAttribute('data-sample-2');
        let id3 = this.getAttribute('data-sample-3');


        this.querySelectorAll(`select:not(#${s}) option`).forEach((el) => {
          if (el.value == id1 || el.value == id2 || el.value == id3 ) {
            el.disabled = true;
          } else {
            el.disabled = false;
          }
        });


      } else {
   // block users choosing the same sample when theres multiple choices
   this.querySelectorAll(`select:not(#${s}) option`).forEach((el) => {
    if (el.value == id) {
      el.disabled = true;
    } else {
      el.disabled = false;
    }
  });
      }
    }

    addSamples() {

      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.add('disabled');
      }

      let _items = this.dataset;
      let ids = [];

      for (var i in _items) {
        ids.push({
          id: _items[i],
          quantity: 1,
          properties: {
            _sample_item: true,
            _sample_key: `sample-${i}`,
          },
        });
      }

      let formData = {
        items: ids,
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          Karmoon.EventBus.emit('AddToCart:itemAdded', res);
          if (document.querySelector('#sample-picker')) {
            document
              .querySelector('#sample-picker')
              .classList.add('visually-hidden');
          }
          if(document.querySelector('#sample-prompt')) {
            document.querySelector('#sample-prompt').classList.add('visually-hidden');
          }
          this.unRender();
          if(document.querySelector('.button--checkout')) {
            document.querySelector('.button--checkout').classList.remove('disabled');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    dataToObject(dataset) {
      return Object.keys(dataset).reduce(function (object, key) {
        if (dataset[key].includes('ref')) {
          return false;
        } else {
          object[key] = dataset[key];
          return object;
        }
      }, {});
    }
  }

  customElements.define('samples-wrapper', SamplesWrapper);



  class GiftWrapper extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('select').forEach((el) => {
        el.addEventListener('change', (e) => {
          this.hydrateSamples(e.currentTarget.id, e.currentTarget.value);
        });
      });

      this.querySelector('#samples-add').addEventListener('click', (e) => {
        if(this.getAttribute('s-count') == "1") {
          if(this.getAttribute('data-sample-1') != "") {
            this.addSamples();
          }
        } else if(this.getAttribute('s-count') == "2") {
          if(this.getAttribute('data-sample-1') != "" && this.getAttribute('data-sample-2') != "") {
            this.addSamples();
          }
        } else {
          if(this.getAttribute('data-sample-1') != "" && this.getAttribute('data-sample-2') != "" && this.getAttribute('data-sample-3') != "") {
            this.addSamples();
          }
        }

      });

      this.querySelector('#samples-closer').addEventListener('click', (e) => {
        this.parentElement.classList.add('visually-hidden');
      });
    }

    static get observedAttributes() {
      return ['data-sample-1', 'data-sample-2', 'data-sample-3'];
    }

    attributeChangedCallback() {
      if(this.getAttribute('s-count') == "1") {
        if(this.getAttribute('data-sample-1') != "") {
          this.querySelector('#samples-add').classList.remove('disabled');
        }
      } else if(this.getAttribute('s-count') == "2") {
        if(this.getAttribute('data-sample-1') != "" && this.getAttribute('data-sample-2') != "") {
          this.querySelector('#samples-add').classList.remove('disabled');
        }
      } else {
        if(this.getAttribute('data-sample-1') != "" && this.getAttribute('data-sample-2') != "" && this.getAttribute('data-sample-3') != "") {
          this.querySelector('#samples-add').classList.remove('disabled');
        }
      }
    }

    render() {
      this.setAttribute('freegift-ref', '');

      const defaultValues = this.dataToObject(this.dataset);

      Object.keys(defaultValues).forEach((key, i) => {
        const value = defaultValues[key];
        // this.disableDefaults(key, value, i + 1);
      });
    }

    disableDefaults(i, id, index) {

      if(this.getAttribute('s-count') == "1") {
        return false;
      } else if(this.getAttribute('s-count') == "2") {
        this.querySelectorAll(`select#${i} option`).forEach((el, _index) => {
          if(el.selected && _index == 0) {
            el.nextElementSibling.disabled = true;
          } else if (el.selected && _index == 1) {
            el.previousElementSibling.disabled = true;
          }
        })
      } else {
        // 3 rule
        this.querySelectorAll(`select#${i} option`).forEach((el, _index) => {
          if(el.selected && _index == 0) {
            el.nextElementSibling.disabled = true;
            el.nextElementSibling.nextElementSibling.disabled = true;
          } else if (el.selected && _index == 1) {
            el.previousElementSibling.disabled = true;
            el.nextElementSibling.disabled = true;
          } else if (el.selected && _index == 2) {
            el.previousElementSibling.disabled = true;
            el.previousElementSibling.previousElementSibling.disabled = true;

          }
        })

      }
    }

    connectedCallback() {
      this.render();
    }

    show() {
      document.querySelector('#fg-wrapper').classList.remove('visually-hidden');
      // if(document.querySelector('#sample-prompt')) {
      //   document.querySelector('#sample-prompt').classList.remove('visually-hidden');
      // }
    }

    hide() {
      document.querySelector('#fg-wrapper').classList.add('visually-hidden');
      // if(document.querySelector('#sample-prompt')) {
      //   document.querySelector('#sample-prompt').classList.add('visually-hidden');
      // }
    }

    unRender() {
      // document.querySelector('#cs-wrapper').remove();
      // this.remove();
      this.hide();
    }

    hydrateSamples(s, id) {
      this.setAttribute(`data-${s}`, id);

      if(this.getAttribute('s-count') == "3") {

        let id1 = this.getAttribute('data-sample-1');
        let id2 = this.getAttribute('data-sample-2');
        let id3 = this.getAttribute('data-sample-3');


        this.querySelectorAll(`select:not(#${s}) option`).forEach((el) => {
          if (el.value == id1 || el.value == id2 || el.value == id3 ) {
            el.disabled = true;
          } else {
            el.disabled = false;
          }
        });


      } else {
   // block users choosing the same sample when theres multiple choices
   this.querySelectorAll(`select:not(#${s}) option`).forEach((el) => {
    if (el.value == id) {
      el.disabled = true;
    } else {
      el.disabled = false;
    }
  });
      }
    }

    addSamples() {

      if(document.querySelector('.button--checkout')) {
        document.querySelector('.button--checkout').classList.add('disabled');
      }

      let _items = this.dataset;
      let ids = [];

      for (var i in _items) {
        console.log(i);
        ids.push({
          id: _items[i],
          quantity: 1,
          properties: {
            _gift_item: true,
            _gift_key: `sample-${i}`,
          },
        });
      }

      let formData = {
        items: ids,
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          Karmoon.EventBus.emit('AddToCart:itemAdded', res);
          if (document.querySelector('#free-gift-picker')) {
            document
              .querySelector('#free-gift-picker')
              .classList.add('visually-hidden');
          }
          // if(document.querySelector('#sample-prompt')) {
          //   document.querySelector('#sample-prompt').classList.add('visually-hidden');
          // }
          this.unRender();
          if(document.querySelector('.button--checkout')) {
            document.querySelector('.button--checkout').classList.remove('disabled');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    dataToObject(dataset) {
      return Object.keys(dataset).reduce(function (object, key) {
        if (dataset[key].includes('ref')) {
          return false;
        } else {
          object[key] = dataset[key];
          return object;
        }
      }, {});
    }
  }

  customElements.define('free-gift-wrapper', GiftWrapper);

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};